export default __webpack_public_path__ + "static/media/H1005.4.32656ab4.mp3";